import { TFunction } from "react-i18next";

export const floatOrIntegerOptions = (t: TFunction<"translation", undefined>) => [
  { value: "true", label: t("preferences.option_integer") },
  { value: "false", label: t("preferences.option_decimal") }
];
